export const START_LOADING = 'app/services/Planner/START_LOADING';
export const GET_AVAILABILITY_SUCCESS = 'app/services/Planner/GET_AVAILABILITY_SUCCESS';
export const GET_AVAILABILITY_FAIL = 'app/services/Planner/GET_AVAILABILITY_FAIL';
export const SWAP_PREV_AVAILABILITY = 'app/services/Planner/SWAP_PREV_AVAILABILITY';
export const SWAP_NEXT_AVAILABILITY = 'app/services/Planner/SWAP_NEXT_AVAILABILITY';
export const SET_INITIAL_STATE = 'app/services/Planner/SET_INITIAL_STATE';
export const CHANGE_PLANNER_MODE = 'app/services/Planner/CHANGE_PLANNER_MODE';
export const GET_APPOINTMENTS_SUCCESS = 'app/services/Planner/GET_APPOINTMENTS_SUCCESS';
export const GET_APPOINTMENTS_FAIL = 'app/services/Planner/GET_APPOINTMENTS_FAIL';
export const REMOVE_APPOINTMENT_SUCCESS = 'app/services/Planner/REMOVE_APPOINTMENT_SUCCESS';
export const REMOVE_APPOINTMENT_FAIL = 'app/services/Planner/REMOVE_APPOINTMENT_FAIL';
export const UPDATE_APPOINTMENT_SUCCESS = 'app/services/Planner/UPDATE_APPOINTMENT_SUCCESS';
export const UPDATE_APPOINTMENT_FAIL = 'app/services/Planner/UPDATE_APPOINTMENT_FAIL';

export const startLoading = () => ({
  type: START_LOADING,
});

export const receivedAvailabilitySuccess = ({ availability, vehicles }) => ({
  type: GET_AVAILABILITY_SUCCESS,
  payload: { availability, vehicles },
});

export const receivedAvailabilityFail = (errors) => ({
  type: GET_AVAILABILITY_FAIL,
  payload: { errors },
});

export const swapPrevAvailability = () => ({
  type: SWAP_PREV_AVAILABILITY,
});

export const swapNextAvailability = () => ({
  type: SWAP_NEXT_AVAILABILITY,
});

export const setInitialState = () => ({
  type: SET_INITIAL_STATE,
});

export const changePlannerMode = () => ({
  type: CHANGE_PLANNER_MODE,
});

export const receivedAppointmentsSuccess = (res) => ({
  type: GET_APPOINTMENTS_SUCCESS,
  payload: { appointments: res },
});

export const receivedAppointmentsFail = (errors) => ({
  type: GET_APPOINTMENTS_FAIL,
  payload: { errors },
});

export const removedAppointmentSuccess = (id: number) => {
  return {
    type: REMOVE_APPOINTMENT_SUCCESS,
    payload: { id },
  };
};

export const removedAppointmentFail = (errors) => ({
  type: REMOVE_APPOINTMENT_FAIL,
  payload: { errors },
});

export const updateAppointmentSuccess = (appointment) => {
  return {
    type: UPDATE_APPOINTMENT_SUCCESS,
    payload: { appointment },
  };
};

export const updateAppointmentFail = (errors) => ({
  type: UPDATE_APPOINTMENT_FAIL,
  payload: { errors },
});
